import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			rx: 14,
			fill: "#1d4ed8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22 L52 22 L56 32 L8 32 Z",
			fill: "#eff6ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22 L52 22 L54 27 L10 27 Z",
			fill: "#bfdbfe"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14,
			y: 32,
			width: 36,
			height: 20,
			fill: "#eff6ff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 28,
			y: 38,
			width: 8,
			height: 14,
			rx: 1,
			fill: "#1d4ed8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 44,
			cy: 42,
			r: 3,
			fill: "#60a5fa"
		})
	]
});
export default SvgLogo;
